import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'System Settings|Tagging|Add Domain Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Tagging,
	portal: 'SP',
};

export type SPTaggingAddDomainModalLocNames =
	| 'SPTaggingAddDomainModalTitle'
	| 'SPTaggingAddDomainModalLabelDomainName'
	| 'SPTaggingAddDomainModalErrorDomainNameRequired'
	| 'SPTaggingAddDomainModalButtonCancel'
	| 'SPTaggingAddDomainModalButtonContinue'
	| 'SPTaggingAddDomainModalNotificationSuccess';

export const spTaggingAddDomainModalLocs: LocDefs<SPTaggingAddDomainModalLocNames> = {
	SPTaggingAddDomainModalTitle: {
		defaultValue: 'Add New Domain',
		description: 'Modal title.',
		displayPath: `${pathStart}Modal Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.Tagging.AddDomainModal.Title.AddNewDomain',
		...sharedProperties,
	},
	SPTaggingAddDomainModalLabelDomainName: {
		defaultValue: 'Domain Name',
		description: 'Label for Domain Name',
		displayPath: `${pathStart}Domain Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.Tagging.AddDomainModal.FieldLabel.DomainName',
		...sharedProperties,
	},
	SPTaggingAddDomainModalErrorDomainNameRequired: {
		defaultValue: 'Domain Name is required',
		description: 'Error shown when domain name is required',
		displayPath: `${pathStart}Domain Name Required`,
		displayType: 'Error',
		// legacyName: 'Tagging/SystemSettings.Tagging.AddDomainModal.FieldError.DomainNameRequired',
		...sharedProperties,
	},
	SPTaggingAddDomainModalButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.Tagging.AddDomainModal.Button.Cancel',
		...sharedProperties,
	},
	SPTaggingAddDomainModalButtonContinue: {
		defaultValue: 'Continue',
		description: 'Continue button',
		displayPath: `${pathStart}Continue`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.Tagging.AddDomainModal.Button.Continue',
		...sharedProperties,
	},
	SPTaggingAddDomainModalNotificationSuccess: {
		defaultValue: 'Your request was successfully submitted',
		description: 'Message shown when there was a success creating a domain',
		displayPath: `${pathStart}Success`,
		displayType: 'Notification',
		// legacyName: 'Tagging/SystemSettings.Tagging.Domains.NotificationMessage.Success',
		...sharedProperties,
	},
};

export type SPTaggingAddDomainModalLocType = LocMap<SPTaggingAddDomainModalLocNames>;
